import { render } from "./FooterComponent.vue?vue&type=template&id=30c8988e&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=30c8988e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c8988e"]])

export default __exports__